import React, { Suspense, useEffect, useState } from 'react';
import { subscribeToWidgetRenders } from './ComponentRenderRegistry';
import WidgetPortal from './WidgetPortal';

const GlobalContextsContainer = React.lazy(
    () => import(/* webpackChunkName: "GlobalContext"*/ '../Global/GlobalContextsContainer')
);

const RootComponent: React.FCC<{ globalData: GlobalData }> = ({ globalData }) => {
    const [widgetConfigs, setWidgetConfigs] = useState<ReactWidgetConfig[]>([]);

    useEffect(() => {
        return subscribeToWidgetRenders(setWidgetConfigs);
    }, [setWidgetConfigs]);

    return (
        <div className="bootstrap-4">
            <Suspense fallback={null}>
                <GlobalContextsContainer globalData={globalData}>
                    {widgetConfigs.map(([compName, reactId, widgetProps, prefetchPromise]) => (
                        <WidgetPortal
                            key={reactId}
                            compName={compName}
                            reactId={reactId}
                            widgetProps={widgetProps}
                            prefetchPromise={prefetchPromise}
                        />
                    ))}
                </GlobalContextsContainer>
            </Suspense>
        </div>
    );
};

export default RootComponent;
